<template>
  <div class="phone">
    <keep-alive include="Database,SetDetail,Scanner">
      <router-view/>
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return { _scrollY: 0 }
  },
  mounted () {
    // iOS Safari 修复：popup 打开时固定 body，关闭时恢复滚动位置
    this._observer = new MutationObserver(() => {
      const locked = document.body.classList.contains('van-overflow-hidden')
      if (locked) {
        this._scrollY = window.scrollY
        document.body.style.position = 'fixed'
        document.body.style.top = `-${this._scrollY}px`
        document.body.style.left = '0'
        document.body.style.right = '0'
      } else {
        document.body.style.position = ''
        document.body.style.top = ''
        document.body.style.left = ''
        document.body.style.right = ''
        window.scrollTo(0, this._scrollY)
      }
    })
    this._observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    })
  },
  beforeDestroy () {
    if (this._observer) this._observer.disconnect()
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Roboto:wght@400;500;600;700;900&display=swap');

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
}

html, body {
  width: 100%;
  font-family: 'Roboto', sans-serif;
  color: #fff;
  -webkit-font-smoothing: antialiased;
}

body {
  background: #0D1B2E;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  min-height: 100vh;
  min-height: 100dvh;
}

#app {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

.phone {
  width: 390px;
  min-height: 100dvh;
  background: #0D1B2E;
  border-radius: 44px;
  overflow: visible;
  display: flex;
  flex-direction: column;
  position: relative;
  box-shadow:
    0 40px 100px rgba(0, 0, 0, 0.85),
    0 0 0 1px rgba(255, 255, 255, 0.07),
    inset 0 1px 0 rgba(255, 255, 255, 0.07);
}
.van-popup--bottom {
  max-width: 390px !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
}
@media (max-width: 430px) {
  .phone {
    width: 100vw;
    min-height: 100vh;
    min-height: 100dvh;
    border-radius: 0;
  }
}

/* Vant Toast 深色风格覆盖 */
.van-toast {
  background: rgba(20, 34, 54, 0.95) !important;
  border: 1px solid rgba(255, 255, 255, 0.06) !important;
  color: #fff !important;
}

.van-toast__text {
  color: #fff !important;
}

/* Vant Popup 深色风格覆盖 */
.van-popup {
  background: #142236 !important;
  color: #fff !important;
}

.van-overlay {
  background: rgba(0, 0, 0, 0.7) !important;
  height: 100vh !important;
  height: 100dvh !important;
}

/* Vant Dialog 深色风格覆盖 */
.van-dialog {
  background: #142236 !important;
  border-radius: 20px !important;
  border: 1px solid rgba(255, 255, 255, 0.08) !important;
}

.van-dialog__header {
  color: #fff !important;
}

.van-dialog__message {
  color: #B0C4DE !important;
}

/* 滚动条隐藏 */
* {
  scrollbar-width: none;
}
*::-webkit-scrollbar {
  display: none;
}
</style>